
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateDocumentLinkDtoFormGroup() {
return new FormGroup({
    active: new FormControl<boolean | undefined>(undefined),
    syncStatus: new FormControl<string | undefined>(''),
    lastSyncError: new FormControl<string | undefined>(''),
})
;
}
      